function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hanger_svg__clip0_1_42)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 3.784c0-.498-.091-.996-.274-1.427a3.861 3.861 0 00-.76-1.228 3.672 3.672 0 00-1.127-.83A2.93 2.93 0 003.53 0c-.456 0-.913.1-1.308.299a3.486 3.486 0 00-1.126.83 4.042 4.042 0 00-.761 1.228c-.183.431-.274.93-.274 1.427 0 .133.03.266.06.365a.97.97 0 00.183.3.725.725 0 00.274.198.997.997 0 00.335.067c.122 0 .244-.034.335-.067a.863.863 0 00.274-.199.79.79 0 00.182-.299c.03-.1.061-.232.061-.365 0-.265.061-.498.122-.73.091-.232.213-.432.365-.598a1.73 1.73 0 01.548-.398c.213-.1.426-.133.67-.133.243 0 .456.067.67.133.212.1.395.232.547.398.152.166.274.366.365.598.091.232.122.465.122.73 0 .266-.061.498-.122.73a1.903 1.903 0 01-.365.598 1.725 1.725 0 01-.548.398c-.213.1-.426.133-.67.133-.456 0-.912.1-1.308.299-.426.2-.791.465-1.126.83A4.042 4.042 0 00.274 8C.09 8.432 0 8.93 0 9.427v4.714c0 .266.06.498.122.73.091.233.213.432.365.598.152.166.335.299.548.398.213.1.426.133.67.133h3.56c.244 0 .457-.066.67-.133.213-.1.395-.232.548-.398.152-.166.274-.365.365-.598.091-.232.152-.498.152-.73V3.784z",
  fill: "currentColor"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "hanger_svg__clip0_1_42"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h7v16H0z"
})));
function SvgHanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgHanger;